import { render, staticRenderFns } from "./trending-products.vue?vue&type=template&id=7510113a&scoped=true&"
import script from "./trending-products.vue?vue&type=script&lang=js&"
export * from "./trending-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7510113a",
  null
  
)

export default component.exports